export const resizeImgUrl = (url: string | null | undefined, config: string) => {
  if (url === null || url === undefined) return undefined
  return `https://img.presync.io/${config}/${url}`
}
